import { PathBase } from "@constellation-academy/epic-ui";

export class LicenseDefinitionsPath extends PathBase {
	static readonly pathKey = "licenseDefinitions";
	static readonly pathName = "license-definitions";
}
